// React 15 -> 16 compatibility
// Need to update dependencies and application code to stop relying on this.
const React = require('react');
React.PropTypes = require('prop-types');
React.createClass = require('create-react-class');



// WEBPACK FOOTER //
// ./src/react-polyfills.js